import tw from 'tailwind-styled-components';
import { Grid, Column, SubTitle, Paragraph } from '@bidalihq/ui';
import { ShieldCheck, CreditCard } from 'styled-icons/heroicons-outline';

import Section from '@/components/section';

const FeatureContainer = tw.div`
  flow-root
  rounded-2xl
  bg-slate-50
  px-6
  pb-8
`;

const Features = () => {
  return (
    <Section className="relative text-center">
      <h2 className="text-base font-semibold uppercase tracking-wider text-indigo-600">Grow faster</h2>
      <SubTitle className="text-gray-900 font-bold">
        Everything you need to engage and retain your customers
      </SubTitle>
      <Paragraph className="mx-auto mt-5 max-w-prose text-xl text-gray-500">
        Transform the way you grow your business with our unique next generation branded currency and cashback rewards solution.
      </Paragraph>

      <Grid className="pt-12 gap-8" columns={[1, 2, 3]}>
        {features.map((feature, index) => (
          <Column key={feature.name} className="pt-6">
            <FeatureContainer>
              <div className="-mt-6">
                <div>
                  <span className="inline-flex items-center justify-center rounded-md bg-indigo-500 p-3 shadow-double">
                    <feature.icon className="h-6 w-6 text-white" aria-hidden="true" />
                  </span>
                </div>
                <h3 className="mt-8 text-lg font-medium tracking-tight text-gray-900">{feature.name}</h3>
                <Paragraph className="mt-5 text-gray-500">{feature.description}</Paragraph>
              </div>
            </FeatureContainer>
          </Column>
        ))}
      </Grid>

    </Section>
  )
};

export default Features;

const features = [
  {
    name: 'Brand Loyalty',
    description: 'Elevate brand engagement with an integrated in-app financial experience.',
    icon: CreditCard,
  },
  {
    name: 'Efficient Promotions',
    description: 'Measure marketing success and reduce unnecessary advertising expenses.',
    icon: CreditCard,
  },
  {
    name: 'Global Reach',
    description: 'Operate worldwide with fewer regulatory barriers and faster setup.',
    icon: CreditCard,
  },
  {
    name: 'Reduced Overhead',
    description: 'Slash operational costs, offering more value to customers.',
    icon: CreditCard,
  },
  {
    name: 'Employee Attraction',
    description: 'Competitive perks and rewards make for a compelling employer brand.',
    icon: ShieldCheck,
  },
  {
    name: 'Talent Retention',
    description: 'Foster loyalty with transparent and immediate recognition of employee efforts.',
    icon: CreditCard,
  },

];
